var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Router-view'),_c('TableroHeader',{staticClass:"header",attrs:{"boardId":_vm.boardId}},[_c('div',{staticClass:"typesBoards"},_vm._l((_vm.typesOfBoard),function(typeOfBoard){return _c('vs-button',{key:typeOfBoard.value,attrs:{"border":"","active":typeOfBoard.name == _vm.selectedType},on:{"click":function($event){_vm.selectedType = typeOfBoard.name}}},[_c('i',{class:`${
            typeOfBoard.name == 'Kanban'
              ? 'fab fa-trello'
              : 'fas fa-chart-gantt'
          } mr-2`,staticStyle:{"font-size":"1rem"}}),_vm._v(" "+_vm._s(typeOfBoard.name)+" ")])}),1)]),_c(_vm.typeOfBoard,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }